module.exports = __webpack_public_path__ + "static/media/light-divider.6b0ba3ce.png";